// extracted by mini-css-extract-plugin
export default {"root_image_inner":"mediaShortsForm_root_image_inner__l4yFq","formTabs_root":"mediaShortsForm_formTabs_root__S5pOB"};